import { ColumnsWithLetter } from './types/model';
import * as pinyin_ from 'pinyin';
const pinyin = pinyin_;
export function map2WithLetter(v: string[]) {
	const mapList = new Map<string, string[]>();
	v.forEach(vv => {
		let headerLetter: string;
		// å¢å å¯¹è±æå­æ®µçæ¯æ
		if (vv.match('^[a-zA-Z].*')) {
			headerLetter = vv[0].toUpperCase();
		} else {
			headerLetter = pinyin(vv, { style: pinyin.STYLE_FIRST_LETTER }).map(s => s[0])[0];
		}
		if (mapList.has(headerLetter)) {
			mapList.get(headerLetter).push(vv);
		} else {
			mapList.set(headerLetter, [vv]);
		}
	});
	// æåº

	const rev = [] as ColumnsWithLetter[];
	mapList.forEach((columns, letter) => {
		rev.push({ Letter: letter, Columns: columns } as ColumnsWithLetter);
	});
	return rev.sort((a, b) => a.Letter.localeCompare(b.Letter));
}
